/**
 *
 * @license Royal Canin
 * @contributors :
 *  - Amar YASSA
 */

import { ShareRecommendationData } from '@app/core/models/share-recommendation-data';
import { createAction, props } from '@ngrx/store';

export const setShareRecommendation = createAction(
  '[Share Recommendation] Set Share Recommendation',
  props<{ data: ShareRecommendationData }>(),
);
export const resetShareRecommendation = createAction('[Share Recommendation] Reset Share Recommendation');

export const requestGenerateNewRecommendationRandomId = createAction(
  '[Share Recommendation] Request Generate New Recommendation Random ID',
  props<{ productIds: string[] }>(),
);
export const generateNewRecommendationRandomId = createAction(
  '[Share Recommendation] Generate New Recommendation Random ID',
  props<{ id: string; flowId: string; randomId: string }>(),
);
export const resetRecommendationRandomIds = createAction('[Share Recommendation] Reset Recommendation Random IDs');
export const setVetComments = createAction('[Share Recommendation] Update Vet Comments', props<{ vetComments: string }>());
export const setDisplayVetComments = createAction(
  '[Share Recommendation] Update Display Vet Comments',
  props<{ displayVetComments: boolean }>(),
);
export const setTargetWeightForWLP = createAction(
  '[Share Recommendation] Set pet target weight for WLP',
  props<{ targetWeight: number }>(),
);
